
import { mapMutations, mapState } from 'vuex';
import { authClient, userClient } from '@/apis';
import log from '@/utils/log';
import { defineComponent } from 'vue';
import { useProcessAvatar } from '@/composables';

export default defineComponent({
  setup() {
    const { processAvatar } = useProcessAvatar();
    return {
      processAvatar,
    };
  },
  data: () => ({
    isAvatarUploading: false,
    isInfoModifying: false,
    nickname: '',
    bio: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  }),
  computed: {
    ...mapState(['user']),
    isInfoModified(): boolean {
      return this.bio !== (this.user.bio || '') || this.nickname !== (this.user.nickname || '');
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapMutations(['setUserProfile']),
    fetchData() {
      this.bio = this.user.bio || '';
      this.nickname = this.user.nickname || '';
    },
    handleClickModifyAvatar() {
      this.$el.querySelector('#upload').click();
    },
    handleAvatarUploaded(f: File) {
      if (!f) {
        this.$message.warn('文件上传失败');
        return;
      }
      if (f.size > 200000) {
        this.$message.warn('请使用不超过 200KB 的图片');
        return;
      }
      this.isAvatarUploading = true;
      const data = new FormData();
      data.append('file', f);
      userClient.uploadAvatar({ userAvatar: data })
        .then((resp) => {
          this.setUserProfile(resp);
          this.$message.success('修改头像成功！');
        })
        .catch((err) => {
          this.$message.error('修改头像失败');
          log.error(err);
        })
        .finally(() => {
          this.isAvatarUploading = false;
        });
    },
    handleClickModifyInfo() {
      if (this.nickname.length > 10) {
        this.$message.warn('昵称最长 10 个字哦！');
        return;
      }
      if (this.bio.length > 50) {
        this.$message.warn('个性签名最长 50 个字哦');
        return;
      }
      this.isInfoModifying = true;
      userClient.editUserInfo({ nickname: this.nickname, bio: this.bio })
        .then((resp) => {
          this.setUserProfile(resp);
          this.$message.success('修改成功！');
        })
        .catch((err) => {
          this.$message.error('修改失败！');
          log.error(err);
        })
        .finally(() => {
          this.isInfoModifying = false;
        });
    },
    handleClickChangePassword() {
      if (this.newPassword !== this.confirmPassword) {
        this.$message.warn('两次输入的新密码不一致哦！');
        return;
      }
      if (this.oldPassword === this.newPassword) {
        this.$message.warn('新密码和旧密码一样哦！');
        return;
      }
      if (this.newPassword === '') {
        this.$message.warn('新密码不能为空哦！');
        return;
      }
      if (this.newPassword.length < 6) {
        this.$message.warn('密码长度至少为 6 个字符哦！');
        return;
      }
      if (this.newPassword.length > 32) {
        this.$message.warn('密码长度最多为 32 个字符哦！');
        return;
      }
      authClient.changePassword({ oldPassword: this.oldPassword, newPassword: this.newPassword })
        .then(() => {
          this.$message.success('修改成功！');
          this.oldPassword = '';
          this.newPassword = '';
          this.confirmPassword = '';
        });
    },
  },
});
